import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../style/policy.css";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  return (
    <div className="policy-container">
      <button className="policy-back-btn" onClick={() => navigate("/")}>
        Back
      </button>
      <h1>Terms & Conditions</h1>
      <div className="policy-content">
        <p>
          These Terms of Service govern your access to and use of GR GPT. By using the
          platform, you agree to these terms.
        </p>

        <h2>Service Scope</h2>
        <p>
          GR GPT provides AI-assisted access to government resolution search, summaries,
          and related informational workflows. Responses are provided for convenience and
          research support.
        </p>

        <h2>No Official Legal Advice</h2>
        <p>
          GR GPT is not a law firm, government department, or official legal advisor.
          Platform responses may summarize documents, but users should verify important
          matters against the original government notification, GR, circular, portal, or
          official authority.
        </p>

        <h2>Account Responsibility</h2>
        <p>
          You are responsible for maintaining the confidentiality of your login credentials
          and for activity carried out through your account.
        </p>

        <h2>Acceptable Use</h2>
        <ul>
          <li>Do not use the platform for unlawful, abusive, or fraudulent activity.</li>
          <li>Do not attempt to disrupt, reverse engineer, or compromise the service.</li>
          <li>Do not upload malicious code, spam, or misleading content.</li>
          <li>Do not misuse the platform to impersonate officials or misrepresent GR GPT output as an official government order.</li>
        </ul>

        <h2>Accuracy and Availability</h2>
        <p>
          We aim to keep GR GPT useful and reliable, but we do not guarantee uninterrupted
          availability, complete accuracy, or that every response will be current, complete,
          or error-free.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          GR GPT may rely on third-party infrastructure, AI providers, analytics tools, or
          external links. We are not responsible for third-party systems or websites.
        </p>

        <h2>Intellectual Property</h2>
        <p>
          The GR GPT application, branding, UI, and platform code are protected by applicable
          intellectual property laws. Government documents and third-party content remain
          subject to their respective ownership and usage rules.
        </p>

        <h2>Suspension or Termination</h2>
        <p>
          We may suspend or terminate access if we reasonably believe a user is violating
          these terms, creating security risk, or misusing the platform.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, GR GPT is provided on an "as is" and
          "as available" basis. We are not liable for indirect, incidental, or consequential
          losses arising from your use of or inability to use the platform.
        </p>

        <h2>Privacy</h2>
        <p>
          Your use of the platform is also governed by our <Link to="/privacy">Privacy Policy</Link>.
        </p>

        <h2>Changes to Terms</h2>
        <p>
          We may update these terms from time to time. Continued use of GR GPT after changes
          are posted constitutes acceptance of the updated terms.
        </p>

        <h2>Governing Law</h2>
        <p>
          These terms are governed by the laws of India, subject to applicable local legal
          requirements.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms may be sent through our <Link to="/contact">Contact Support</Link> page or to <strong>grgptsupport@gmail.com</strong>.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
